module.exports = __webpack_public_path__ + "static/img/icon-en-3.9e4d0824.png";